<template lang="pug">
div
    div.row
        div.col-xs-9
            small.pull-right Subtotal
        div.col-xs-3
            small.pull-right {{ subTotal }}

    //- Discount list
    div.row(v-for="discount in discounts")
        div.col-xs-9
            div.pull-right.text-right
                small {{ discount.name }}
                small.block.text-muted(v-if="discount.remarks !== ''") {{ discount.remarks }}
        div.col-xs-3
            small.pull-right {{ discount.amount }}

    //- Total after discount
    div.row(v-if="hasDiscount")
        div.col-xs-9
            small.pull-right After Discount
        div.col-xs-3
            small.pull-right {{ totalAfterDiscount }}

    //- charges
    div.row(v-for="charge in charges")
        div.col-xs-9
            small.pull-right {{ charge.charge.name }}
        div.col-xs-3
            small.pull-right {{ charge.amount }}

    //- taxes
    div.row(v-for="tax in taxes")
        div.col-xs-9
            small.pull-right {{ tax.tax.name }}
        div.col-xs-3
            small.pull-right {{ tax.amount }}

    //- rounding
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Rounding
        div.col-xs-3
            small.pull-right {{ rounding }}

    //- grand total
    div.row.text-md
        div.col-xs-9
            small.pull-right.grand-total-label Grand Total
        div.col-xs-3.grand-total-amount
            small.pull-right {{ grandTotal }}

    //- payments
    div.row(v-for="payment in payments")
        .col-xs-12(v-if="payment.card")
            .row
                .col-xs-9.text-muted
                    small.pull-right {{ getTerminalName(payment) }}
            .row
                .col-xs-9
                    small.pull-right(v-if="payment.reference_number == null") {{ payment.card.name }}
                    small.pull-right(v-else) {{ payment.card.name }} - {{ payment.reference_number }}
                .col-xs-3
                    small.pull-right {{ payment.amount }}

        div(v-if="!payment.card")
            .col-xs-9.text-muted(v-if="payment.name === 'On Account'")
                small.pull-right {{ payment.name }}
            .col-xs-9(v-if="payment.name === 'On Account'")
                small.pull-right {{ payment.company_name }} ({{ payment.reference_number }})
            .col-xs-9(v-if="payment.name === 'QR Pay'")
                small.pull-right {{ payment.name }} - {{ payment.payment_method }}({{ payment.reference_number }})
            .col-xs-9(v-else)
                small.pull-right(v-if="payment.reference_number == null") {{ payment.name }} {{ payment.pay_at_forecourt ? '(Forecourt)' : null }}
                small.pull-right(v-else) {{ payment.name }} - {{ payment.reference_number }}
            .col-xs-3
                small.pull-right {{ payment.type === 0 ? payment.original_amount ? payment.original_amount : payment.amount : payment.amount }}

    //- change
    div.row(v-if="paymentName.includes('cash')")
        div.col-xs-9
            small.pull-right Change
        div.col-xs-3
            small.pull-right {{ totalChange }}

    //- fuel change cash
    div.row(v-if="paymentName.includes('cash') && totalFuelChange != 0")
        div.col-xs-9
            small.pull-right Fuel Change Cash
        div.col-xs-3
            small.pull-right {{ totalFuelChange }}
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'discounts',
            'totalDiscount',
            'totalAfterDiscount',
            'charges',
            'taxes',
            'totalChange',
            'payments',
            'fuel',
            'paymentName',
            'subTotal',
            'grandTotal',
            'rounding',
            'totalFuelChange',
        ]),

        hasDiscount() {
            return this.discounts.length > 0;
        },
    },

    methods: {
        getTerminalName(payment) {
            if (this.fuel) {
                let tid = this.fuel.terminal_id;
                let tty = this.fuel.terminal_type;

                if (tid && tty) {
                    return `${tty} (${tid})`;
                }
            }

            return payment.name;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/amount.vue